<script>
    import Customers from '@/services/Customers';
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Swal from "sweetalert2";

    export default {
        components: { vueDropzone: vue2Dropzone },
        props: ['userData'],
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                acceptedFileTypeErrorMessage:'',
                acceptedFileTypeError:false,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                UserPictureDeleted: false,
                customer_id : this.$route.params.id ,
                user_picture : '' ,
                hasUserPicture: false,
                dropzoneOptions_user_picture: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: false,
                    thumbnailWidth: 100,
                  thumbnailMethod: 'contain',
                    maxFilesize: 5,
                    acceptedFiles: 'image/jpeg,image/png,image/webp',
                    maxFiles: 1,
                  previewTemplate: `
          <div class="dz-preview dz-file-preview">
            <div class="dz-image">
              <img data-dz-thumbnail />
              <div class="button-overlay">
                <button id="custom-add-btn" type="button" class="custom-hover-change custom-border-radius shadow border-1 cursor-pointer btn  bg-white text-black btn-sm d-flex align-items-center justify-content-center gap-1" data-dz-remove>
                <i class="uil uil-edit text-black"></i>
                  <span class="cursor-pointer fw-medium">Change</span>
                </button>
              </div>
            </div>
          </div>
  `
                },
            };
        },
        methods: {
            refreshData() {
                this.$emit('onRefresh')
            },

            closeModal() {
                this.showModal = false;
                this.resetProps();
                this.UserPictureDeleted = false;
            },

            resetProps() {
                this.submitted = false
            },

            selectUserPicture(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_user_picture.getQueuedFiles();
                    if(files[0].accepted == false){
                      this.acceptedFileTypeErrorMessage = 'File not accepted | Accepted formats are png, jpg, webp | Max size 5MB';
                      this.acceptedFileTypeError = true;
                    }else{
                      this.acceptedFileTypeErrorMessage = '';
                      this.acceptedFileTypeError = false;
                    }

                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only select one image');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_user_picture.removeFile(value);
                        });
                    }
                    this.user_picture = queuedFiles[0];
                }, 250);
            } ,

          deleteUserPicture() {
                this.UserPictureDeleted = true;
                this.user_picture = '';
            },

          async editUserPicture() {
            if (this.acceptedFileTypeError) return;
            this.tryingToEdit = true;
            this.submitted = true;

            try {
              const data = {
                user_picture: this.user_picture,
                csrf_token: this.csrf_token,
                _method: 'PATCH'
              };
              await Customers.editUserPicture(this.customer_id, data).then((response) => {
                this.successmsg("Changes has been saved");
                this.closeModal();
              }).catch(error => {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.failedmsg(this.error)
              }).finally(() => {
                this.refreshData()
                this.tryingToEdit = false
              })
            } catch (error) {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error)
            }

            this.tryingToEdit = false;
          },
          removeUserPicture() {
            Swal.fire({
              title: "Delete User Picture?",
              text: "Your picture will be deleted!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Delete"
            }).then(async (result) => {
              if (result.isConfirmed === true) {
                try {
                  const response = await Customers.deleteUserPicture(this.customer_id);
                  if (response.data.customer) {
                    this.successmsg('User Picture Successfully Deleted!');
                    this.closeModal();
                    this.refreshData();
                  }
                } catch (error) {
                  this.error = error.response.data.error ? error.response.data.error : "An error occurred while deleting user picture";
                  this.failedmsg(this.error);
                }
              }
            })
          },
          syncData(){
              this.user_picture = this.userData.user_picture;
              if(this.user_picture !== ''){
                 this.hasUserPicture = true;
              }else{
                this.hasUserPicture = false;
              }
          }
        }
    };</script>

<template>
    <b-modal @hidden="resetProps" v-model="showModal"  @shown="syncData" id="user_picture" title="Change User Picture" title-class="font-18" centered>
        <form @submit.prevent="editUserPicture">
<!--{{userData}}-->
            <div class="form-group " >
<!--                <label for="user_picture">User Picture:</label>-->

                <template v-if="!UserPictureDeleted && hasUserPicture">
                    <b-form-group label-for="image" class="mb-3 text-center image-area">
                        <img :src="`${user_picture}`" alt="" width="200" class="img-thumbnail" />
                    </b-form-group>
                    <div class="text-center mt-3">
                        <a class="btn text-primary" title="Change Image" @click="deleteUserPicture">
                            <i class="uil uil-pen font-size-18"></i>
                        </a>
                    </div>
                </template>
                <template v-else>
                  <div :class="['userPicture-upload',submitted ? 'is-invalid' : '', acceptedFileTypeError ? 'has-error' : '']">
                    <vue-dropzone
                            id="dropzone_user_picture"
                            ref="myVueDropzone_user_picture"
                            class="d-flex align-items-center justify-content-center p-0"
                            :use-custom-slot="true"
                            :options="dropzoneOptions_user_picture"
                            @vdropzone-files-added="selectUserPicture"
                            no-progress-bar
                    >
<!--                      <div class="userPicture-upload__placeholder">-->
<!--                        <i class="uil uil-import"></i>-->
<!--                        <span>Drag and drop an image, or click to browse</span>-->
<!--                        <small>PNG, JPG up to 5MB</small>-->
<!--                      </div>-->
                      <div class="dropzone-custom-content">
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             class="lucide lucide-upload w-12 h-12 custom-color-gray-400 mb-4">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <polyline points="17 8 12 3 7 8"></polyline>
                          <line x1="12" x2="12" y1="3" y2="15"></line>
                        </svg>
                        <h3 class="dropzone-custom-title custom-color-gray-400 font-size-16">Drop files here to upload</h3>
                        <div class="subtitle custom-color-gray-400 font-size-16">or click to upload</div>
                        <p class="subtitle custom-color-gray-400 font-size-16 mt-1">PNG, JPG up to 5MB</p>

                      </div>
                    </vue-dropzone>
                    <p v-if="acceptedFileTypeError" class="text-danger">{{acceptedFileTypeErrorMessage}}</p>
                  </div>
                </template>
            </div>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>
        <template v-slot:modal-footer>
          <div class="w-100 d-flex align-items-center  p-0">
            <div v-if="hasUserPicture" class="w-50 d-flex align-items-center justify-content-start p-0">
              <b-button variant="danger" @click="removeUserPicture">Delete User Picture</b-button>
            </div>
            <div :class="{'w-100': !hasUserPicture}" class="w-50 d-flex align-items-center justify-content-end gap-2 p-0">
              <b-button variant="light" @click="closeModal">Close</b-button>
              <b-button variant="primary" @click="editUserPicture" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
            </div>
          </div>
        </template>
    </b-modal>
</template>
<style>


#dropzone_user_picture .dz-preview .dz-image {
width: 300px !important;
display: flex;
align-items: center;
justify-content: center;
  padding: 20px !important;
}

#dropzone_user_picture .dz-preview .dz-image img {
object-fit: contain;
/* Ensures the image scales without cropping */
max-width: 100%;
max-height: 100%;
}

/* Remove ALL hover effects */
#dropzone_user_picture .dz-preview:hover .dz-image img {
filter: none !important;
transform: none !important;
opacity: 1 !important;
}

#dropzone_user_picture .dz-preview .dz-image::before,
#dropzone_user_picture .dz-preview .dz-image::after {
display: none !important;
content: none !important;
}

#dropzone_user_picture .dz-preview:hover {
opacity: 1 !important;
background: none !important;
}

#dropzone_user_picture .dz-preview:hover .dz-details {
opacity: 1 !important;
background: none !important;
}

#dropzone_user_picture .dz-preview .dz-details {
opacity: 1 !important;
position: relative !important;
background: none !important;
}

/* Remove the semi-transparent overlay on hover */
#dropzone_user_picture .dz-preview .dz-image {
position: relative !important;
}

#dropzone_user_picture .dz-preview:hover .dz-image {
background: none !important;
}



#dropzone_user_picture .dz-preview .dz-progress,
#dropzone_user_picture .dz-preview .dz-success-mark,
#dropzone_user_picture .dz-preview .dz-error-mark {
display: none !important;
}

/* Make preview full width */
#dropzone_user_picture .dz-preview {
width: 200px !important;
margin: 0 !important;
}

#dropzone_user_picture .dz-preview .dz-image {
width: 100% !important;
height: auto !important;
display: flex;
align-items: center;
justify-content: center;
position: relative !important;
}

#dropzone_user_picture .dz-preview .dz-image img {
object-fit: contain;
max-width: 100%;
height: auto;
width: 100%;
}

/* Overlay buttons on top of image */
.button-overlay {
  position: absolute;
  top: 80%;
  left: 98%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 10px;
  z-index: 55;
  width: 100%;
  opacity: 0;  /* Hide by default */
  transition: opacity 0.3s ease;  /* Smooth transition */
}

#dropzone_user_picture .dz-preview:hover .button-overlay {
  opacity: 1;  /* Show on hover */
}

</style>